import apiClient from './api';

// User Service
export const userService = {
  // Lấy thông tin profile user
  getProfile: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}`);
      return response.data;
    } catch (error) {
      // Silently handle 404 errors - this is expected for some user IDs
      if (error.response?.status === 404) {
        console.log(`User profile not found for ID: ${userId.substring(0, 8)}...`);
      } else {
        console.warn(`Failed to get profile for user ${userId}:`, error.response?.status);
      }
      return null;
    }
  },

  // Cập nhật thông tin profile
  updateProfile: async (userId, userData) => {
    try {
      const response = await apiClient.put(`/users/${userId}`, userData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Xóa user
  deleteUser: async (userId) => {
    try {
      const response = await apiClient.delete(`/users/${userId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Lấy danh sách users với phân trang
  getUsers: async (page = 1, limit = 10) => {
    try {
      const response = await apiClient.get(`/users?page=${page}&limit=${limit}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Tìm kiếm user (frontend-friendly). Simplified to avoid multiple API calls.
  searchUsers: async (query, page = 1, limit = 2) => {
    try {
      // Try the most common endpoint first
      const res = await apiClient.get(`/Users/search`, { params: { username: query, page, limit } });
      return res.data;
    } catch (error) {
      // Silently handle search failures - this is expected for some queries
      if (error.response?.status === 400 || error.response?.status === 404) {
        console.log(`No users found for query: ${query.substring(0, 8)}...`);
      } else {
        console.warn(`Search failed for query ${query}:`, error.response?.status);
      }
      return [];
    }
  },

  // Save psychometric results for a user
  savePsychometric: async (userId, psychometricPayload) => {
    try {
      const response = await apiClient.post(`/users/${userId}/psychometric`, psychometricPayload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Get psychometric results for a user
  getPsychometric: async (userId) => {
    try {
      const response = await apiClient.get(`/users/${userId}/psychometric`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};